module.exports = __webpack_public_path__ + "img/arrow-right-short.9f81b0bb.svg";